/**
 * Sales Portal Daylight Ambience applies only to /sales/* staff routes.
 * Service Portal, customer-facing pages, and in-sales preview links are excluded.
 */

const GLOBAL_CUSTOMER_PREFIXES = [
  "/p/",
  "/proposal/",
  "/proposal-manual/",
  "/project/",
  "/proposal-wrapper/",
  "/terms/",
  "/invoice/",
  "/ro-invoice/",
  "/ro-delivery/",
  "/deal-invoice/",
  "/portal-invoice/",
  "/track/",
  "/u/",
] as const;

/** Customer-facing views linked from Sales (Link A, project preview, etc.). */
const SALES_CUSTOMER_VIEW_PATTERNS: RegExp[] = [
  /^\/sales\/proposals\/[^/]+\/preview-manual\/?$/,
  /^\/sales\/proposals\/[^/]+\/preview\/?$/,
  /^\/sales\/projects\/[^/]+\/interactive-preview(?:\/|$)/,
];

export function normalizePathname(pathname: string): string {
  const raw = (pathname || "/").split("?")[0]?.split("#")[0] ?? "/";
  if (raw.length > 1 && raw.endsWith("/")) return raw.slice(0, -1);
  return raw || "/";
}

/** True only on Sales Portal staff pages when ambience may render. */
export function isSalesPortalAmbienceEligiblePath(pathname: string): boolean {
  const path = normalizePathname(pathname);
  if (!path.startsWith("/sales")) return false;
  if (GLOBAL_CUSTOMER_PREFIXES.some((prefix) => path.startsWith(prefix))) return false;
  if (SALES_CUSTOMER_VIEW_PATTERNS.some((rx) => rx.test(path))) return false;
  return true;
}

/** @deprecated Use isSalesPortalAmbienceEligiblePath */
export function isDaylightModeEligiblePath(pathname: string): boolean {
  return isSalesPortalAmbienceEligiblePath(pathname);
}
